export default "__VITE_ASSET__Bw5WclB9__"